import { supabase } from './supabaseClient'

export function effectivePlan(rows = []) {
  const ranks = { starter: 1, basic: 2, premium: 3 }
  return rows.filter(row => ['active', 'trialing'].includes(String(row?.status || '').toLowerCase()))
    .map(row => String(row.plan || '').toLowerCase())
    .reduce((best, plan) => (ranks[plan] || 0) > ranks[best] ? plan : best, 'starter')
}

export async function loadActivePlan(userId) {
  const { data, error } = await supabase.rpc('hubbing_active_plan')
  if (!error && ['starter', 'basic', 'premium'].includes(data)) return data
  // Supports staged deployment: both existing billing sources are checked.
  const results = await Promise.all([
    supabase.from('subscriptions').select('plan,status').eq('user_id', userId),
    supabase.from('stripe_web_subscriptions').select('plan,status').eq('user_id', userId).eq('livemode', true),
  ])
  for (const result of results) if (result.error) throw result.error
  return effectivePlan(results.flatMap(result => result.data || []))
}
